import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
let defaultName = '';
try {
  if (localStorage.name) {
    defaultName = localStorage.name
  }
} catch (e) {
}
const store = new Vuex.Store({
  state: {
    userInfo: {
      userName: "",
      password: ""
    }, 
    per: {
      name: defaultName
    },
    weeks_content: getweek()
  },
  mutations: {
    namechange(state, name) {
      state.per.name = name;
      try {
        localStorage.name = name;
      } catch (e) {

      }
    }
  }
});


function getweek() {


  return [

    {
      todos: [{
        text: "暂无排班",
        time_start: "",
        time_end: "",
        guahao_type: "",
        selectTime: "",
        active: false,
        findIndex_active: false,
        date: ''
      }]
    },
    {
      todos: [{
        text: "暂无排班",
        time_start: "",
        time_end: "",
        guahao_type: "",
        selectTime: "",
        active: false,
        findIndex_active: false,
        date: ''
      }]
    },
    {
      todos: [{
        text: "暂无排班",
        time_start: "",
        time_end: "",
        guahao_type: "",
        selectTime: "",
        active: false,
        findIndex_active: false,
        date: ''
      }]
    },
    {
      todos: [{
        text: "暂无排班",
        time_start: "",
        time_end: "",
        guahao_type: "",
        selectTime: "",
        active: false,
        findIndex_active: false,
        date: ''
      }]
    },
    {
      todos: [{
        text: "暂无排班",
        time_start: "",
        time_end: "",
        guahao_type: "",
        selectTime: "",
        active: false,
        findIndex_active: false,
        date: ''
      }]
    },
    {
      todos: [{
        text: "暂无排班",
        time_start: "",
        time_end: "",
        guahao_type: "",
        selectTime: "",
        active: false,
        findIndex_active: false,
        date: ''
      }]
    },
    {
      todos: [{
        text: "暂无排班",
        time_start: "",
        time_end: "",
        guahao_type: "",
        selectTime: "",
        active: false,
        findIndex_active: false,
        date: ''
      }]
    }
  ];
}

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js